/*global _ */
import {Vue} from '~/addiesaas'
import BaseMixin from './base'

export default {
  data() {
    return {
      propDefs: {}
    }
  },
  mixins: [BaseMixin],
  methods: {
    probeComponent(componentName, defaultComponent) {
      if (componentName in Vue.options.components || componentName in this.$options.components) {
        return componentName
      }
      return defaultComponent
    },
    getComponentClasses() {
      return [this.classes, ...this.getComponentExtraClasses()]
    },
    getComponentExtraClasses() {
      return []
    }
  }
}

